"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolResultOutput = toolResultOutput;
const json_1 = require("../../utils/json");
/** Package normalized parts without interpreting or normalizing their contents. */
function toolResultOutput(parts, fallback) {
    if (parts.length === 0 ||
        !parts.every((part) => part.type !== "tool-call" && part.type !== "tool-result")) {
        return { type: "json", value: (0, json_1.toJsonValue)(fallback) };
    }
    const [part] = parts;
    // Only unwrap bare scalar parts; annotations and metadata stay on the part.
    if (parts.length === 1) {
        if (part.type === "text" &&
            Object.keys(part).every((key) => key === "type" || key === "text")) {
            return { type: "text", value: part.text };
        }
        if (part.type === "data" &&
            Object.keys(part).every((key) => key === "type" || key === "value")) {
            return { type: "json", value: part.value };
        }
    }
    return { type: "content", value: parts };
}
